import React, { useEffect } from 'react';

import { useAuth } from '@lucidhq/ui-auth';

import { useTheme } from './ThemeProvider';

export const ThemeSwitcher = () => {
  const { setDefaultTheme, setDisneyTheme } = useTheme();
  const { user } = useAuth();

  useEffect(() => {
    if (user?.email?.includes('@disney.com')) setDisneyTheme();
    else setDefaultTheme();
  }, [user, setDisneyTheme, setDefaultTheme]);

  return <></>;
};
